<template>
  <div class="container">
    <div class="tabs is-toggle is-fullwidth is-dynamic-size ">
      <ul>
        <!--  <li :class="isActive($options.LIST)">
          <router-link
            tag="a"
            :to="{ name: $options.LIST }"
          >
            {{ $t('domains.pages.list') }}
          </router-link>
        </li> -->
        <li :class="isActive($options.OVERVIEW)">
          <router-link
            tag="a"
            :to="{ name: $options.OVERVIEW }"
          >
            {{ $t('domains.pages.overview') }}
          </router-link>
        </li>
        <li :class="isActive($options.CONTACTS)">
          <router-link
            tag="a"
            :to="{ name: $options.CONTACTS }"
          >
            {{ $t('domains.pages.contacts') }}
          </router-link>
        </li>
        <!--
        <li :class="isActive($options.ADVANCED_SETTINGS)">
          <router-link
            tag="a"
            :to="{ name: $options.ADVANCED_SETTINGS }"
          >
            {{ $t('domains.pages.advanced') }}
          </router-link>
        </li>
        -->
      </ul>
    </div>
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import generatedSiteplusUrlMixin from '@/mixins/siteplus-generated-urls'

export default {
  name: 'TestDomain',
  mixins: [generatedSiteplusUrlMixin],
  data () {
    return {
      isModalVisible: true
    }
  },
  computed: {
    ...mapState(['services', 'account']),
    ...mapGetters('domainService', ['hasPendingDomain', 'hasRegisteredDomain', 'hasPendingDomainSelection', 'domainData'])
  },
  watch: {
    siteplusWebsiteDetails: {
      handler (obj) {
        if (obj !== null) {
          if (obj.domainName === null || (obj.domainName !== this.domainData.domainName)) {
            this.showModal()
          }
        }
      }
    }
  },
  created () {
    this.$options.CONTACTS = 'DomainContacts'
    this.$options.OVERVIEW = 'DomainOverview'
    this.$options.ADVANCED_SETTINGS = 'DomainAdvancedSettings'
    this.$options.LIST = 'DomainList'
  },
  methods: {
    isActive (name) {
      const { $route } = this
      return { 'is-active': $route.matched.some(n => n.name === name) }
    },
    closeModal () {
      this.isModalVisible = false
    },
    showModal () {
      this.$root.$emit('show::custom::modal', 'assign-services')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../sass/_variables.scss';

  .tabs.is-dynamic-size {
    ul {
      font-size: 1.5rem;
    }
  }

  @media only screen and (max-width: $break-small) {
    .tabs.is-dynamic-size {
      ul {
        display: block;
        font-size: 1.25rem;
        text-align: center;
      }
    }
  }
</style>
